import { Masonry } from '@leagueplatform/masonry';
import { MASONRY } from 'common/constants';
import { usePageViewAnalytics } from '@leagueplatform/analytics';
import { useIntl } from '@leagueplatform/locales';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { MasonryPageLayout } from 'components/masonry-page-layout/masonry-page-layout.component';

export const AppointmentLanding = () => {
  usePageViewAnalytics({ screen_name: 'Appointments Landing' });
  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: 'STR_APPOINTMENTS' }));

  return (
    <MasonryPageLayout>
      <Masonry rootNodeId={MASONRY.ROOT_NODE_APPOINTMENTS_LANDING_PAGE} />
    </MasonryPageLayout>
  );
};
